// extracted by mini-css-extract-plugin
export default {"root":"Handle_root__e1Iz8"};